// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * SUREnet polis-public API
 * OpenAPI spec version: 1
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type { CollectionResultOfAanvragenPolissenGetPakketPolissenByRelatiePakketPolisDto } from '../model/collectionResultOfAanvragenPolissenGetPakketPolissenByRelatiePakketPolisDto';

import type { MicrosoftAspNetCoreHttpHttpValidationProblemDetails } from '../model/microsoftAspNetCoreHttpHttpValidationProblemDetails';

import type { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails';

import type { PolisGetPolissenParams } from '../model/polisGetPolissenParams';

import type { PolisGetTerugvalParams } from '../model/polisGetTerugvalParams';

import type { Result1OfAanvragenPolissenBerekenTerugvalDto } from '../model/result1OfAanvragenPolissenBerekenTerugvalDto';

import type { Result1OfAanvragenPolissenGetWagenparkcontractafsprakenDto } from '../model/result1OfAanvragenPolissenGetWagenparkcontractafsprakenDto';

import type { Result1OfSUREbusinessCCSWebservicesFeaturesPolisPolisVersieLezenPolisDetailsDto } from '../model/result1OfSUREbusinessCCSWebservicesFeaturesPolisPolisVersieLezenPolisDetailsDto';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Polis.PolisInzien</li></ul>
 * @summary Haalt de polissen op van een relatie
 */
export const polisGetPolissen = (
  params?: MaybeRef<PolisGetPolissenParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customInstance<CollectionResultOfAanvragenPolissenGetPakketPolissenByRelatiePakketPolisDto>(
    { url: `/api/v2/polissen`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getPolisGetPolissenQueryKey = (params?: MaybeRef<PolisGetPolissenParams>) => {
  return ['api', 'v2', 'polissen', ...(params ? [params] : [])] as const;
};

export const getPolisGetPolissenQueryOptions = <
  TData = Awaited<ReturnType<typeof polisGetPolissen>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRef<PolisGetPolissenParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof polisGetPolissen>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPolisGetPolissenQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof polisGetPolissen>>> = ({ signal }) =>
    polisGetPolissen(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof polisGetPolissen>>,
    TError,
    TData
  >;
};

export type PolisGetPolissenQueryResult = NonNullable<Awaited<ReturnType<typeof polisGetPolissen>>>;
export type PolisGetPolissenQueryError = ErrorType<void>;

/**
 * @summary Haalt de polissen op van een relatie
 */

export function usePolisGetPolissen<
  TData = Awaited<ReturnType<typeof polisGetPolissen>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRef<PolisGetPolissenParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof polisGetPolissen>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPolisGetPolissenQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Polis.PolisInzien</li></ul>
 * @summary Haal de details van een individuele polis op
 */
export const polisGetPolisDetails = (
  polisnummer: MaybeRef<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  polisnummer = unref(polisnummer);

  return customInstance<Result1OfSUREbusinessCCSWebservicesFeaturesPolisPolisVersieLezenPolisDetailsDto>(
    { url: `/api/v2/polissen/${polisnummer}/details`, method: 'GET', signal },
    options,
  );
};

export const getPolisGetPolisDetailsQueryKey = (
  polisnummer: MaybeRef<string | undefined | null>,
) => {
  return ['api', 'v2', 'polissen', polisnummer, 'details'] as const;
};

export const getPolisGetPolisDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof polisGetPolisDetails>>,
  TError = ErrorType<void>,
>(
  polisnummer: MaybeRef<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof polisGetPolisDetails>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPolisGetPolisDetailsQueryKey(polisnummer);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof polisGetPolisDetails>>> = ({ signal }) =>
    polisGetPolisDetails(polisnummer, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => unref(polisnummer) !== null && unref(polisnummer) !== undefined),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof polisGetPolisDetails>>, TError, TData>;
};

export type PolisGetPolisDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof polisGetPolisDetails>>
>;
export type PolisGetPolisDetailsQueryError = ErrorType<void>;

/**
 * @summary Haal de details van een individuele polis op
 */

export function usePolisGetPolisDetails<
  TData = Awaited<ReturnType<typeof polisGetPolisDetails>>,
  TError = ErrorType<void>,
>(
  polisnummer: MaybeRef<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof polisGetPolisDetails>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPolisGetPolisDetailsQueryOptions(polisnummer, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Polis.PolisInzien</li></ul>
 * @summary Haalt de samenvatting van een wagenparkcontract op basis van contractnummer op
 */
export const polisGetWagenparkcontract = (
  contractnummer: MaybeRef<number | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  contractnummer = unref(contractnummer);

  return customInstance<Result1OfAanvragenPolissenGetWagenparkcontractafsprakenDto>(
    { url: `/api/v2/polissen/${contractnummer}/wagenparkcontract`, method: 'GET', signal },
    options,
  );
};

export const getPolisGetWagenparkcontractQueryKey = (
  contractnummer: MaybeRef<number | undefined | null>,
) => {
  return ['api', 'v2', 'polissen', contractnummer, 'wagenparkcontract'] as const;
};

export const getPolisGetWagenparkcontractQueryOptions = <
  TData = Awaited<ReturnType<typeof polisGetWagenparkcontract>>,
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
>(
  contractnummer: MaybeRef<number | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof polisGetWagenparkcontract>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPolisGetWagenparkcontractQueryKey(contractnummer);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof polisGetWagenparkcontract>>> = ({
    signal,
  }) => polisGetWagenparkcontract(contractnummer, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => unref(contractnummer) !== null && unref(contractnummer) !== undefined),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof polisGetWagenparkcontract>>, TError, TData>;
};

export type PolisGetWagenparkcontractQueryResult = NonNullable<
  Awaited<ReturnType<typeof polisGetWagenparkcontract>>
>;
export type PolisGetWagenparkcontractQueryError = ErrorType<
  void | MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
>;

/**
 * @summary Haalt de samenvatting van een wagenparkcontract op basis van contractnummer op
 */

export function usePolisGetWagenparkcontract<
  TData = Awaited<ReturnType<typeof polisGetWagenparkcontract>>,
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
>(
  contractnummer: MaybeRef<number | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof polisGetWagenparkcontract>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPolisGetWagenparkcontractQueryOptions(contractnummer, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Polis.PolisInzien</li></ul>
 * @summary Bereken de bonus-malus-terugval van een subpolis
 */
export const polisGetTerugval = (
  polisnummer: MaybeRef<string | undefined | null>,
  params?: MaybeRef<PolisGetTerugvalParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  polisnummer = unref(polisnummer);
  params = unref(params);

  return customInstance<Result1OfAanvragenPolissenBerekenTerugvalDto>(
    {
      url: `/api/v2/polissen/${polisnummer}/terugval`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPolisGetTerugvalQueryKey = (
  polisnummer: MaybeRef<string | undefined | null>,
  params?: MaybeRef<PolisGetTerugvalParams>,
) => {
  return ['api', 'v2', 'polissen', polisnummer, 'terugval', ...(params ? [params] : [])] as const;
};

export const getPolisGetTerugvalQueryOptions = <
  TData = Awaited<ReturnType<typeof polisGetTerugval>>,
  TError = ErrorType<
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
    | void
  >,
>(
  polisnummer: MaybeRef<string | undefined | null>,
  params?: MaybeRef<PolisGetTerugvalParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof polisGetTerugval>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPolisGetTerugvalQueryKey(polisnummer, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof polisGetTerugval>>> = ({ signal }) =>
    polisGetTerugval(polisnummer, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => unref(polisnummer) !== null && unref(polisnummer) !== undefined),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof polisGetTerugval>>, TError, TData>;
};

export type PolisGetTerugvalQueryResult = NonNullable<Awaited<ReturnType<typeof polisGetTerugval>>>;
export type PolisGetTerugvalQueryError = ErrorType<
  MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails | void
>;

/**
 * @summary Bereken de bonus-malus-terugval van een subpolis
 */

export function usePolisGetTerugval<
  TData = Awaited<ReturnType<typeof polisGetTerugval>>,
  TError = ErrorType<
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
    | void
  >,
>(
  polisnummer: MaybeRef<string | undefined | null>,
  params?: MaybeRef<PolisGetTerugvalParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof polisGetTerugval>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPolisGetTerugvalQueryOptions(polisnummer, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
